import isEmpty from "lodash/isEmpty";
export default function noSelectedText() {
    var _a;
    return isEmpty((_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.toString());
}
